import { render, staticRenderFns } from "./addorupdate.vue?vue&type=template&id=578ef9f7&scoped=true&"
import script from "./addorupdate.vue?vue&type=script&lang=js&"
export * from "./addorupdate.vue?vue&type=script&lang=js&"
import style0 from "./addorupdate.vue?vue&type=style&index=0&id=578ef9f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ef9f7",
  null
  
)

export default component.exports